import { TableCell, TableRow } from 'semantic-ui-react';
import { PencilSimpleLine } from '@phosphor-icons/react';
import { Link } from 'react-router-dom';
import { ItemImage, OrganisationAvatar } from '../../../components';
import { BoldText, MuteText } from '../../../elements';
import { theme } from '../../../utility';

export function LocationItemRow({ item }) {
  return (
    <TableRow>
      <TableCell>
        <div className="d-flex align-items-center">
          <ItemImage size="mini" item={item} imageKey="product" displayImageKey="image" />
          <div className="ml-2">
            <BoldText>{item.product.sku}</BoldText>
            <div className="d-flex align-items-center">
              <OrganisationAvatar
                name={item.customerOrganization?.company_name}
                image={item.customerOrganization?.logo?.url}
                mini
              />
              <span className="ml-1">{item.customerOrganization?.company_name}</span>
            </div>
          </div>
        </div>
      </TableCell>
      <TableCell>
        {item.available} <MuteText>Units</MuteText>
      </TableCell>
      <TableCell>{item.lotNumber}</TableCell>
      <TableCell>
        <Link to={`/app/inventory/item/${item.inventoryId}`}>
          <PencilSimpleLine
            className="cursor-pointer"
            color={theme.colors.grey}
            size={17}
          />
        </Link>
      </TableCell>
    </TableRow>
  );
}
